import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CTAButton {
  id: string;
  key: string;
  label: string;
  icon_name: string;
  tanya_greeting: string;
  tanya_context_hint: string;
  sort_order: number;
  active: boolean;
  form_id: string | null;
}

export function useCTAButtons() {
  return useQuery({
    queryKey: ["cta-buttons"],
    queryFn: async (): Promise<CTAButton[]> => {
      const { data, error } = await supabase
        .from("cta_buttons")
        .select("*")
        .eq("active", true)
        .order("sort_order");
      if (error) throw error;
      return (data ?? []) as CTAButton[];
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useCTAButtonsAll() {
  return useQuery({
    queryKey: ["cta-buttons-all"],
    queryFn: async (): Promise<CTAButton[]> => {
      const { data, error } = await supabase
        .from("cta_buttons")
        .select("*")
        .order("sort_order");
      if (error) throw error;
      return (data ?? []) as CTAButton[];
    },
  });
}
